import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import {
  CHAT_DUOTONE_ICON,
  MAP_MARKER_DUOTONE_ICON,
  PHONE_DUOTONE_ICON,
} from "../../../utils/svgs_duotone";
import { AppIcon } from "../../Generic/AppIcon";

interface Props {
  onClickChat: () => void;
  onClickCallPatient: () => void;
  onClickDirections: () => void;
}

const PatientScreenExtraHeaderActions = (props: Props) => {
  return (
    <div className="PatientScreenExtraHeaderActions">
      <div onClick={props.onClickChat}>
        <AppIcon icon={CHAT_DUOTONE_ICON} size={24} />
        <strong>{translate(STRINGS.CHAT)}</strong>
      </div>

      <div onClick={props.onClickCallPatient}>
        <AppIcon icon={PHONE_DUOTONE_ICON} size={24} />
        <strong>{translate(STRINGS.CALL)}</strong>
      </div>

      <div onClick={props.onClickDirections}>
        <AppIcon icon={MAP_MARKER_DUOTONE_ICON} size={24} />
        <strong>{translate(STRINGS.DIRECTIONS)}</strong>
      </div>
    </div>
  );
};

export default React.memo(PatientScreenExtraHeaderActions);
